import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import skillookAdmin from 'apis/skillookAdmin';
import { mapKeys, omit } from 'lodash';

// First, create the thunk

// Get All Job Request
export const allJobsListRequest = createAsyncThunk(
  'allJobsList',
  async body => {
    const [start, limit] = body;
    const response = await skillookAdmin.get(
      `admin/users/jobs/allJobTitle?limit=${limit}&skip=${start}`
    );
    return response.data.data;
  }
);

// Search All Job Request
export const searchJobsListRequest = createAsyncThunk(
  'searchJobsList',
  async body => {
    const [keyword, start, limit] = body;
    const response = await skillookAdmin.get(
      `admin/users/jobs/search?limit=${limit}&skip=${start}&keyword=${keyword}`
    );
    return { skip: start, data: response.data.data };
  }
);

// Get Single Job Details

export const getSingleJobRequest = createAsyncThunk(
  'getSingleJob',
  async body => {
    const response = await skillookAdmin.post(
      `admin/users/jobs/singleJobTitle`,
      body
    );
    return response.data.data;
  }
);

// Add New Job Request

export const addNewJobRequest = createAsyncThunk('addNewJob', async body => {
  const response = await skillookAdmin.post(
    `admin/users/jobs/addJobTitle`,
    body
  );
  return response.data.data;
});

// Update Job Details Request

export const updateJobRequest = createAsyncThunk('updateJob', async body => {
  await skillookAdmin.post('admin/users/jobs/updateJobTitle', body);
  return body;
});
// Delete Job Request

export const deleteJobRequest = createAsyncThunk('deleteJob', async body => {
  await skillookAdmin.post(`admin/users/jobs/deleteJobTitle`, body);
  return body.id;
});

// Then, handle actions in your reducers:
const jobsListSlice = createSlice({
  name: 'allJobList',
  initialState: { list: {}, totalCount: 0, singleJobData: null },
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
    emptyAllJobsList() {
      return {};
    },
  },
  extraReducers: {
    // Add reducers for additional action types here, and handle loading state as needed
    [allJobsListRequest.fulfilled]: (state, action) => {
      return {
        ...state,
        list: { ...state.list, ...mapKeys(action.payload.jobList, '_id') },
        totalCount: action.payload.totalJobsCount,
      };
    },
    [searchJobsListRequest.fulfilled]: (state, action) => {
      return {
        ...state,
        list:
          action.payload.skip === 0
            ? { ...mapKeys(action.payload.data.jobList, '_id') }
            : { ...state.list, ...mapKeys(action.payload.data.jobList, '_id') },
        totalCount: action.payload.data.totalJobsCount,
      };
    },
    [getSingleJobRequest.fulfilled]: (state, action) => {
      return {
        ...state,
        singleJobData: action.payload,
      };
    },
    [deleteJobRequest.fulfilled]: (state, action) => {
      return {
        ...state,
        list: omit(state.list, action.payload),
        singleJobData: null,
      };
    },
    [addNewJobRequest.fulfilled]: (state, action) => {
      return {
        ...state,
        list: {
          ...state.list,
          [action.payload._id]: {
            _id: action.payload._id,
            jobTitle: action.payload.jobTitle,
          },
        },
      };
    },
  },
});

export const { emptyAllJobsList } = jobsListSlice.actions;
export default jobsListSlice.reducer;
